export default __webpack_public_path__ + "static/den-vau-587bd4535ebaa893a937688568ba67d1.jpeg";